import {
    OpenMobileAppBannerCloseContainerStyled,
    OpenMobileAppBannerLogoContainerStyled,
    OpenMobileAppBannerStyled
} from "./styled/OpenMobileAppBannerStyled";
import BinIcon from "../../components/icon/Icon";
import { useCallback } from "react";
import { setIsOpenMobileAppBannerVisibleAction } from "../../app/appActions";
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getAppFeatures, getIsOpenMobileAppBannerVisible } from '../../app/appSelectors';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext';
import { getAppStoreTitle } from '../../components/ToAppButton/toAppSelectors';
import { PUBLIC_URL } from '../../config';
import { FEATURES } from '../../app/appConstants';
import { getIsCanInstallPwaSelector } from '../Pwa/pwaSelectors';
import PwaInstallButton from '../Pwa/components/PwaInstallButton';

function OpenMobileAppBanner(props) {
    const { appStoreTitle, isOpenMobileAppBannerVisible, setIsOpenMobileAppBannerVisible } = props;
    const { getLangPath } = useLangContext();
    const features = useSelector(getAppFeatures);
    const isCanInstallPwaSelector = useSelector(getIsCanInstallPwaSelector);

    const handleClickCloseButton = useCallback(() => {
        setIsOpenMobileAppBannerVisible(false);
    }, [setIsOpenMobileAppBannerVisible]);

    const isShowBanner = !!features[FEATURES.MOBILE_APP_BANNER] && isCanInstallPwaSelector && isOpenMobileAppBannerVisible;

    return isShowBanner ? <OpenMobileAppBannerStyled>
        <OpenMobileAppBannerCloseContainerStyled onClick={handleClickCloseButton}>
            <BinIcon name='IcClose'/>
        </OpenMobileAppBannerCloseContainerStyled>
        <OpenMobileAppBannerLogoContainerStyled>
            <img src={`${PUBLIC_URL}/assets/logo/logo-icon.svg`} alt='logo'/>
        </OpenMobileAppBannerLogoContainerStyled>
        <div className='d-flex flex-column flex-1 justify-content-center'>
            <div className='f20'>{appStoreTitle}</div>
            <div className='f16 color-white-60'>{getLangPath('store_links.open_in_app')}</div>
        </div>
        <PwaInstallButton onDownloadButtonClick={handleClickCloseButton}/>
    </OpenMobileAppBannerStyled>
    : null;
}

const mapStateToProps = createStructuredSelector({
    appStoreTitle: getAppStoreTitle,
    isOpenMobileAppBannerVisible: getIsOpenMobileAppBannerVisible,
});

const mapDispatchToProps = (dispatch) => ({
    setIsOpenMobileAppBannerVisible: payload => dispatch(setIsOpenMobileAppBannerVisibleAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpenMobileAppBanner);
